import requestStatuses from '@clearscore/constants.request-statuses';

import {
    TRANSACTIONS_FETCH,
    TRANSACTIONS_FETCH_SUCCESS,
    TRANSACTIONS_FETCH_ERROR,
    TRANSACTIONS_UPDATE,
    TRANSACTIONS_UPDATE_SUCCESS,
} from '../transactions.types';

export default function reportReducer(state = {}, action) {
    switch (action.type) {
        case TRANSACTIONS_FETCH:
            return {
                ...state,
                fetchStatus: requestStatuses.PENDING,
            };

        case TRANSACTIONS_FETCH_SUCCESS:
            return {
                ...state,
                fetchStatus: requestStatuses.SUCCESS,
                ...action.payload,
            };

        case TRANSACTIONS_FETCH_ERROR:
            return {
                ...state,
                fetchStatus: requestStatuses.ERROR,
            };
        case TRANSACTIONS_UPDATE:
            return {
                ...state,
                updateStatus: requestStatuses.PENDING,
            };
        case TRANSACTIONS_UPDATE_SUCCESS:
            return {
                ...state,
                updateStatus: requestStatuses.SUCCESS,
            };
        default:
            return state;
    }
}
